import { SiteProvider } from "@/context/SiteContext";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { ServicesSection } from "@/components/ServicesSection";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { HowItWorks } from "@/components/HowItWorks";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { AboutSection } from "@/components/AboutSection";
import { ServiceAreas } from "@/components/ServiceAreas";
import { GallerySection } from "@/components/GallerySection";
import { FAQSection } from "@/components/FAQSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { FloatingCTA } from "@/components/FloatingCTA";

export default function HomePage() {
  return (
    <SiteProvider>
      <div data-testid="home-page" className="pb-16 lg:pb-0">
        <Header />
        <main>
          <HeroSection />
          <ServicesSection />
          <WhyChooseUs />
          <HowItWorks />
          <TestimonialsSection />
          <GallerySection />
          <AboutSection />
          <FAQSection />
          <ServiceAreas />
          <ContactSection />
        </main>
        <Footer />
        <FloatingCTA />
      </div>
    </SiteProvider>
  );
}
